import React from 'react';
import { Card } from 'react-bootstrap';

function Ejercicio() {

    const Entrenadores = [
        { N: 'Carlos Quintero', D: 'La motivación es lo que te pone en marcha, y el hábito es lo que hace que sigas.', I: 'https://images.pexels.com/photos/874158/pexels-photo-874158.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
        { N: 'Maria Solano', D: 'Para tener éxito, en primer lugar debemos creer que podemos.', I: 'https://images.pexels.com/photos/733872/pexels-photo-733872.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
        { N: 'Pedro Almiran', D: 'Da siempre lo mejor de ti. Lo que siembres hoy dará su fruto mañana.', I: 'https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
        { N: 'Camila Nieves', D: 'No se es un perdedor hasta que se deja de intentarlo.', I: 'https://images.pexels.com/photos/1065084/pexels-photo-1065084.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
        { N: 'Jose Guzman', D: 'Acepta los retos para así poder sentir la euforia de la victoria.', I: 'https://images.pexels.com/photos/1076605/pexels-photo-1076605.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' },
        { N: 'Josefina Montes', D: 'La clave para iniciar algo es dejar de hablar y ponerse a realizar.', I: 'https://images.pexels.com/photos/372042/pexels-photo-372042.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1' }
    ];

    return (
        <React.Fragment>
            <section className='tusalud-ejercicio'>
                <h1><span className='logo'>&nbsp;TU&nbsp;</span>SALUD <br /> <span className='subtitle'>Ejercicio</span></h1>
            </section>

            <section className='resumen'>

                <div className='title-center'>
                    <h2>Beneficios del ejercicio</h2>
                    <p>Una alimentación equilibrada es aquella que cubre los requisitos nutricionales necesarios para
                        El ejercicio regular es bueno para la salud y puede ayudarle a bajar de peso. Pero si usted es como muchos,
                        pasa mucho tiempo ocupado, tiene un trabajo sedentario y no se ejercita habitualmente.
                        <br />
                        <br />
                        La buena noticia es que nunca es demasiado tarde para empezar. Usted puede comenzar de a poco y 
                        encontrar maneras de hacer más actividad física en su vida. Para obtener el mayor beneficio, 
                        usted debe tratar de realizar la cantidad recomendada de ejercicio para su edad. Si usted lo logra, 
                        se sentirá mejor, ayudará a prevenir o controlar muchas enfermedades y puede incluso vivir más tiempo.
                        <br />
                        <br />
                        medlineplus, Beneficios del ejercicio
                        <br /> https://medlineplus.gov/spanish/benefitsofexercise.html
                    </p>
                    <h2>Nuestros entrenadores están listos para realizar un entrenamiento especializado para ti.</h2>
                    <div className='especialistas'>
                        {Entrenadores.map(proN => (
                            <Card key={proN.N} style={{ width: '18rem' }}>
                                <Card.Img variant="top" src={proN.I} />
                                <Card.Body>
                                    <Card.Title>{proN.N}</Card.Title>
                                    <Card.Text>
                                        {proN.D}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        ))}
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}
export default Ejercicio;